
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1403Dialog extends Serenity.EntityDialog<Report_1403Row, any> {
        protected getFormKey() { return Report_1403Form.formKey; }
        protected getIdProperty() { return Report_1403Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1403Row.localTextPrefix; }
        protected getNameProperty() { return Report_1403Row.nameProperty; }
        protected getService() { return Report_1403Service.baseUrl; }
        protected getDeletePermission() { return Report_1403Row.deletePermission; }
        protected getInsertPermission() { return Report_1403Row.insertPermission; }
        protected getUpdatePermission() { return Report_1403Row.updatePermission; }

        protected form = new Report_1403Form(this.idPrefix);

    }
}